import Vue from "vue";
import VueRouter from "vue-router";
import Home from '../views/Home.vue'
import { getSession } from "@/services/session";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: "/unmsm-admision-maestria-2021-II",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/panel",
    name: "panel",
    component: () => import("../views/Panel.vue"),
    meta: { requiresStudent: true },
  },
  {
    path: "/examen",
    name: "examen",
    component: () => import("../views/Exam.vue"),
    meta: { requiresStudent: true },
    children: [
      {
        path: "pregunta/:question",
        name: "questionPostulant",
        component: () => import("../views/QuestionPostulant.vue"),
      },
    ],
  },
  {
    path: "/examen-finalizado",
    name: "examEnded",
    component: () => import("../views/ExamFinishedMessage.vue"),
    meta: { requiresStudent: true }
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/Admin.vue"),
    meta: { requiresAdmin: true },
    children: [
      {
        path: "postulante",
        name: "adminPostulante",
        component: () => import("../components/Admin/ResultsByPostulant.vue"),
      },
      {
        path: "events",
        name: "events",
        component: () => import("../modules/examEvent/List.vue"),
      },
      {
        path: "templates",
        component: () => import("../modules/examTemplate/List.vue"),
      },
      {
        path: "templates/:examId",
        component: () => import("../modules/examTemplate/Detail.vue"),
        props: true
      },
      {
        path: "resultados/:eventId",
        name: "resultados",
        component: () => import("../components/Admin/Results.vue"),
        props: true
      }
    ],
  },
  {
    path: "/login-admin-14563243",
    name: "login-admin",
    component: () => import("../views/LoginAdmin.vue"),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    let session = getSession();
    if (session.type == 0) next();
    else
      next({
        name: "login-admin",
      });
  } else if (to.matched.some((record) => record.meta.requiresStudent)) {
    let session = getSession();
    if (session.type == 1) next();
    else
      next({
        name: "login",
      });
  } else next();
});

export default router;
